import React,{useEffect} from "react";
import './Info.scss';
import successIcon from "../assets/icons/successfully_subscribe_tick_icon.png"
import lowBalIcon from "../assets/icons/low_balance_icon.png"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Footer2 from "./Footer2";
import { reactLocalStorage } from "reactjs-localstorage";
import invalidIcon from "../assets/icons/invalid_otp_icon.png"
import logo from "../assets/icons/logo.png"

const Info =(props)=>{
    const lang = localStorage.getItem("lang")
    const homeLogo = props.homeLogo
    const history = useHistory();
    const state=history?.location?.state?.status || reactLocalStorage.get("modal");
    const message=history?.location?.state?.customMessage;
  
    useEffect(() => {
        const handlePopState = (event) => {
          event.preventDefault();
          history.go(1);
        };
    
        window.addEventListener('popstate', handlePopState);
    
        history.push(history.location.pathname);
    
        return () => {
          window.removeEventListener('popstate', handlePopState);
        };
      }, [history]);
    const tryAgain=()=>{
      window.location.replace('/subs')      
    }
    return (
        <div className="containerinfo">
            <img src={homeLogo}
            className="logoinfo"
            alt="logo"/>
            {state==="success"?
            <>
            <div className="icon-container">
                <img className="tick" src={successIcon} alt="Success"
                 />
            </div>
            <h1 className="heading">{lang === "en" ? "Subscription Success" :
             "نجاح الاشتراك"}</h1> 
              <p className="para">{lang === "en" ?"Your Request is taken you will get sms shorty" : 
              "تم أخذ طلبك وسوف تحصل على الرسائل القصيرة القصيرة"}</p> 
            </>:
            <>
             {state==="failure"?
             <>
             <div className="icon-container">
                      <img className="tick" src={invalidIcon} alt="sad" />
                  </div>
                  <h1 className="heading">{lang === "en" ? "Invalid OTP" : "كلمة المرور لمرة واحدة غير صالحة"}</h1>
                  <p className="para">{lang === "en" ?"You have submitted wrong OTP." : ".لقد قمت بإرسال كلمة مرور لمرة واحدة (OTP) خاطئة"}</p>
                  <p className="para" style={{marginTop:"-0.5rem"}}>{lang === "en" ?"Please try again !!":"حاول مرة اخرى !!"}</p>
                   <button className="btninfo" onClick={tryAgain}>{lang === "en" ? "Try Again" : "حاول ثانية"}</button>
              </>:
              <>

               {state==="lowBalance"?
                 <>
               {/* Low Balance Case */}
                <div className="icon-container">
                    <img className="tick" src={lowBalIcon} alt="sad" />
                </div>
                <h1 className="heading">{lang === "en" ? "Low Balance" :"رصيد منخفض"}</h1>
                <p className="para">{lang === "en" ?"You do not have sufficient balance.Please try again !!" : "ليس لديك رصيد كافي"}</p>
                <p className="para" style={{marginTop:"-0.25rem"}}>{lang === "en" ?"Please try again !!":"حاول مرة اخرى !!"}</p>
                 <button className="btninfo" onClick={tryAgain}>{lang === "en" ? "Try Again" : "حاول ثانية"}</button>
                 </>:
                  <>
                    <h1 className="heading">{lang === "en" ? "Subscription Failure" : "فشل الاشتراك"}</h1>
             <p className="para">{lang === "en" ?"Sorry! Seems like your subscription has failed." : "آسف! يبدو أن اشتراكك قد فشل."}</p>
             {message && <p className="para" style={{marginTop:"-0.25rem"}}>{message}</p> }
             {state!=='success' && <button className="btninfo" onClick={tryAgain}>{lang === "en" ? "Try Again" : "حاول ثانية"}</button>}
                   </>
              }
             </>
            }
            </>
       }
            <div className="foot">
            <Footer2/>
        </div>
     </div>       
    );
}

export default Info